// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ReadyToGoRingFragmentDoc } from './ReadyToGoRing.fragment.generated';
import { ReviewsFragmentDoc } from '../../../components/rings/Reviews.generated';
import { ShopWithConfidenceProductFragmentDoc } from '../../../components/cms/component/ComponentShopWithConfidence.generated';
import { DeliveryTimeframeFragmentDoc } from '../../../components/rings/DeliveryTimeframe.generated';
import { AffirmFinanceOptionsFragmentDoc } from '../../../graphql/api/checkout/payment/affirmFinanceOptions.fragment.generated';
import { ProductAnalyticsFragmentDoc } from '../composables/analytics/useProductAnalytics.generated';
import { BlockFragmentDoc } from '../../../components/cms/CmsBlock.fragment.generated';
import { MetaFragmentDoc } from '../../../graphql/api/fragments/meta.fragment.generated';
import { PdpAccordionItemFragmentDoc } from '../../../components/product/PdpAccordion.generated';
import { CtaBoxFragmentDoc } from '../components/CtaBox.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const GetReadyToGoRingDocument = gql`
    query getReadyToGoRing($slug: String!, $metal: MetalCode!, $currency: CurrencyInput!, $region: RegionCode!, $locale: Locale!) {
  catalogueReadyToGoRing(filter: {slug: $slug, primaryMetalCode: $metal}) {
    ...readyToGoRing
    ...shopWithConfidenceProduct
    firstAvailableDeliveryDate(region: $region) {
      ...deliveryTimeframe
    }
    financeOptionsAffirm(currency: $currency, region: $region) {
      ...affirmFinanceOptions
    }
    ...productAnalytics
    reviews {
      ...reviews
    }
  }
}
    ${ReadyToGoRingFragmentDoc}
${ShopWithConfidenceProductFragmentDoc}
${DeliveryTimeframeFragmentDoc}
${AffirmFinanceOptionsFragmentDoc}
${ProductAnalyticsFragmentDoc}
${ReviewsFragmentDoc}`;

export function useGetReadyToGoRingQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.GetReadyToGoRingQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.GetReadyToGoRingQuery, SchemaTypes.GetReadyToGoRingQueryVariables | undefined>({ query: GetReadyToGoRingDocument, variables: undefined, ...options });
};
export const GetReadyToGoRingContentDocument = gql`
    query getReadyToGoRingContent($currency: CurrencyInput!, $region: RegionCode!, $locale: Locale!, $page: String!, $pageFallback: String!) {
  pageProductDetails(path: $page, fallback: $pageFallback, locale: $locale) {
    id
    blocks {
      ...block
    }
    meta {
      ...meta
    }
    accordionItems {
      ...pdpAccordionItem
    }
    ...ctaBox
  }
}
    ${BlockFragmentDoc}
${MetaFragmentDoc}
${PdpAccordionItemFragmentDoc}
${CtaBoxFragmentDoc}`;

export function useGetReadyToGoRingContentQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.GetReadyToGoRingContentQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.GetReadyToGoRingContentQuery, SchemaTypes.GetReadyToGoRingContentQueryVariables | undefined>({ query: GetReadyToGoRingContentDocument, variables: undefined, ...options });
};